import React from "react";
import {
    IonCard,
    IonCardHeader,
    IonCardTitle,
    IonCardContent,
    IonButton,
    IonText,
    IonIcon,
    IonList,
    IonItem,
    IonLabel,
} from "@ionic/react";
import { checkmarkCircle, closeCircle } from "ionicons/icons";
import approvalStore from "../../store/approval";

interface WarehouseRequestDetailProps {
    data: {
        id: string;
        title: string;
        requester: string;
        date: string;
        reason: string;
        status: "pending" | "approved" | "rejected";
    };
}

const WarehouseRequestDetail: React.FC<any> = ({
    data
}) => {
    return (
        <IonCard style={{ borderRadius: "12px", boxShadow: "0 4px 12px rgba(0,0,0,0.1)" }}>
            <IonCardHeader>
                <IonCardTitle>{data?.approval_title}</IonCardTitle>
            </IonCardHeader>
            <IonCardContent>
                <IonText color="medium">
                    <p><b>Alasan:</b> {data?.approval_description}</p>
                    <p><b>Tanggal:</b> {data?.request_date}</p>
                    <p><b>Requester:</b> {data?.requester_name}</p>
                    <p><b>Status:</b> {data?.approval_status.toUpperCase()}</p>
                    <br/>
                    <p><b>Data:</b></p>

                    <IonList lines="full" style={{ border: '1px solid #DEDEDE', borderRadius: 10, padding: 0 }}>
                        {data?.approval_data && data.approval_data.length > 0 && data.approval_data.map((item: any, index: number) => (
                            <IonItem key={index}>
                                <IonLabel><b>{item.serial}</b><br/>({item.sku_code}) - {item.qty} pcs</IonLabel>
                            </IonItem>
                        ))}
                    </IonList>
                </IonText>

                <br/>

                {data?.approval_status === "pending" && (
                    <div style={{ marginTop: "16px" }}>
                        <IonButton
                            expand="full"
                            color="success"
                            onClick={() => approvalStore.approveRequest(data._id)}
                            style={{ marginBottom: 10 }}
                        >
                            <IonIcon icon={checkmarkCircle} slot="start" />
                            Approve
                        </IonButton>
                        <IonButton
                            expand="full"
                            color="danger"
                            onClick={() => approvalStore.rejectRequest(data._id)}
                        >
                            <IonIcon icon={closeCircle} slot="start" />
                            Reject
                        </IonButton>
                    </div>
                )}
            </IonCardContent>
        </IonCard>
    );
};

export default WarehouseRequestDetail;
